import { useCallback } from 'react';

import { LOCAL_STORAGE_KEY } from '@common/constants';
import { makeEEUrlWithNewCode } from '@common/helpers';
import { NotifierType, showNotification } from '@core/components';
import i18n from '@core/i18n/i18n';
import { useAppDispatch } from '@redux/hooks';
import {
    updateEeStatusList,
    updateIgnoreFetchedEstimate,
    updateIsFetchedCustomerData,
} from '@redux/slices/estimateSlice';

interface UseExpiredEstimateActionsProps {}

interface UseExpiredEstimateActionsReturn {
    openToNewEstimate: () => void;
    createCloneEstimate: () => void;
}

export type ExpiredOpenToNewAction = () => void;
export type ExpiredCloneAction = (retainCustomerInfo: boolean) => void;

export const useExpiredEstimateActions = (
    _props: UseExpiredEstimateActionsProps = {}
): UseExpiredEstimateActionsReturn => {
    const dispatch = useAppDispatch();

    const openToNewEstimate = useCallback((): void => {
        window.location.href = makeEEUrlWithNewCode({ [LOCAL_STORAGE_KEY.LOAD_ESTIMATE]: '' }).toString();
    }, []);

    const createCloneEstimate = useCallback((): void => {
        dispatch(updateIgnoreFetchedEstimate(true));
        dispatch(updateEeStatusList([]));
        // dispatch(resetCustomerData());
        dispatch(updateIsFetchedCustomerData(false));

        const description = i18n.t('NOTIFICATIONS.FETCH_ESTIMATE.EXPIRED.COPY_FOLLOWUP.DESC');
        const message = i18n.t('NOTIFICATIONS.FETCH_ESTIMATE.EXPIRED.COPY_FOLLOWUP.MSG');
        const title = i18n.t('NOTIFICATIONS.FETCH_ESTIMATE.EXPIRED.COPY_FOLLOWUP.TITLE');
        showNotification({
            type: NotifierType.WARNING,
            title: title,
            description: (
                <div className="description-container">
                    <div className="Notification Notification__Description">{description}</div>
                    {message && (
                        <div className="Notification__Message" style={{ fontWeight: 'bold' }}>
                            {message}
                        </div>
                    )}
                </div>
            ),
            duration: 0,
        });
    }, [dispatch]);

    return {
        openToNewEstimate,
        createCloneEstimate,
    };
};
